import React from 'react';
import { useQuery } from '@tanstack/react-query';

import { queryClient } from "../App";
import * as QUERIES from "../queries/query-functions";

// These queries are used in a lot of files so they are called from this root file.
export const getBasketData = () => {
    return useQuery({
        queryKey: ['basket'],
        queryFn: QUERIES.getBasket,
        staleTime: 86400000
    });
}
export const refetchBasketData = async () => {
  await queryClient.invalidateQueries({ queryKey: ['basket'], exact: true });
};

export const getCustomer = () => {
    return useQuery({
        queryKey: ['customerData'],
        queryFn: QUERIES.getCustomer,
        staleTime: 86400000,
        retry: false,
    });
}
export const refetchCustomer = () => {
  queryClient.invalidateQueries({ queryKey: ['customerData'], exact: true });
};